import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_GLOBAL_SHARE_BUTTON_CONFIG = createFcmDetails('global_share_button_config', {
	owner: 'starfish',
	context: 'Global config for share buttons',
	description: 'Change the order and filter share buttons globally',
	import: false,
	template: [
		'copy',
		'facebook',
		'instagram',
		'whatsapp',
		'twitter',
		'email',
		'facebookMessenger',
		'sms',
		'line',
		'reddit',
		'nextdoor',
		'vk',
		'mobileNativeShare',
	],
});
